import React, { Component } from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"
import * as Icon from "react-feather"
import remarkReactComponents from "../../helpers/remarkReactComponents"

class ApplyStep extends Component {
  state = {
    displayContent: false,
  }

  toggleContent = () => {
    const { displayContent } = this.state

    this.setState({
      displayContent: !displayContent,
    })
  }

  render() {
    const { displayContent } = this.state
    const { blok } = this.props

    return (
      <SbEditable content={blok}>
        <div className="apply-step">
          <div
            role="button"
            className={[
              "apply-step__heading",
              displayContent ? " apply-step__heading--active" : "",
            ].join(" ")}
            onClick={this.toggleContent}
            onKeyPress={this.toggleContent}
            tabIndex={0}
          >
            <div className="apply-step__group">
              <Icon.ChevronDown
                className={[
                  "apply-step__icon",
                  "icon",
                  "icon--sm",
                  displayContent ? " apply-step__icon--active" : "",
                ].join(" ")}
              />
              <p className="apply-step__title">{blok.title}</p>
            </div>
            <p className="apply-step__time">{blok.time}</p>
          </div>
          <div
            className={[
              "apply-step__content",
              displayContent ? " apply-step__content--visible" : "",
            ].join(" ")}
          >
            {
              unified()
                .use(remarkParse)
                .use(remarkRehype)
                .use(rehypeReact, {
                  createElement: React.createElement,
                  components: remarkReactComponents,
                  Fragment: React.Fragment,
                })
                .processSync(blok.content).result
            }
          </div>
        </div>
      </SbEditable>
    )
  }
}

ApplyStep.propTypes = {
  blok: PropTypes.shape({
    title: PropTypes.string,
    time: PropTypes.string,
    content: PropTypes.string,
  }).isRequired,
}

export default ApplyStep
